export const APP_PACKAGE_NAME = 'bgs.group.eventapp'
export const APP_STORE_APPLE_ID = '6753342613'
export const APP_URL = import.meta.env.VITE_EVENT_APP_APP_URL
